import { useState, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { suggestProductGroup } from "../utils/aiClassification.ts";

export function useAIClassification(existingGroups: string[]) {
  const { mutateAsync, isPending, error, reset } = useMutation({
    mutationFn: (productName: string) => suggestProductGroup(productName, existingGroups),
  });

  return {
    suggestProductGroup: mutateAsync,
    loading: isPending,
    error: error ? error.message : null,
    clearError: reset,
  };
}
